import dynamic from "next/dynamic";

export const ColorPicker = dynamic(
  () => import("./color-picker").then((mod) => ({ default: mod.ColorPicker })),
  { ssr: false }
);
